var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon } from "../../UI";
import { withContext } from "../../componentWrappers";
import { I18NLink, t, Translate } from "../../I18N";
import { SettingsHeader } from "../../Settings/components/SettingsHeader";
import { deletePage } from "../actions/pageActions";

class PagesList extends Component {
  deletePage(page) {
    return this.props.mainContext.confirm({
      accept: () => {
        this.props.deletePage(page.toJS());
      },
      title: /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Confirm deletion of page:"), "\xA0",
      page.get('title')
      ),

      message: 'Are you sure you want to delete this page?'
    });
  }

  render() {
    const { pages } = this.props;
    return /*#__PURE__*/(
      _jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
      _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Pages")
      ), /*#__PURE__*/
      _jsx("ul", { className: "list-group pages" }, void 0,
      pages.map((page, index) => /*#__PURE__*/
      _jsx("li", { className: "list-group-item" }, index, /*#__PURE__*/
      _jsx(I18NLink, { to: `/settings/pages/edit/${page.get('sharedId')}` }, void 0,
      page.get('title')
      ), /*#__PURE__*/
      _jsx("div", { className: "list-group-item-actions" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, {
        to: `/settings/pages/edit/${page.get('sharedId')}`,
        className: "btn btn-default btn-xs" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "pencil-alt" }), " ", /*#__PURE__*/_jsx("span", {}, void 0, t('System', 'Edit'))
      ), /*#__PURE__*/
      _jsx("a", {
        onClick: this.deletePage.bind(this, page),
        className: "btn btn-danger btn-xs template-remove" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "trash-alt" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete")
      )
      )
      )
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "settings-footer" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, { to: "/settings/pages/new", className: "btn btn-default" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "plus" }), ' ', /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Add page")
      )
      )
      )
      ));

  }
}









export function mapStateToProps({ pages }) {
  return { pages };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ deletePage }, dispatch);
}

export { PagesList };
export default connect(mapStateToProps, mapDispatchToProps)(withContext(PagesList));